import '../styles/GoLive.scss';

import { Stack } from '@whistler-ui/k2/components/Stack';
import { Heading, Paragraph } from '@whistler-ui/k2/components/Typography';

import { useThemeStore } from '../../../store/theme';

const componentName = 'c-GoLive';

export function GoLive() {
  const { config } = useThemeStore();

  const image = config.assets.onboarding.goLive;

  return (
    <Stack direction="row" gap={12} className={componentName}>
      <Stack direction="column" gap={8} tag="section">
        <Heading>Go Live</Heading>
        <Stack direction="column" gap={4}>
          <Paragraph>
            With the Beta test completed, you can now sit back and wait until
            the Beta release is made available to the general public.
          </Paragraph>
          <Paragraph>
            As your customers update their handsets with the latest OS version,
            your new ES Use Cases will become available to them.
          </Paragraph>
          <Paragraph>
            You can use our reporting to keep an eye on how the roll out
            progresses and how well your use cases are performing across your
            customer base.
          </Paragraph>
          <Paragraph>
            You can now launch the same use cases with other OEMs and/or add new
            use cases to further enhance the user experience for your customers!
          </Paragraph>
        </Stack>
      </Stack>
      {image && (
        <aside>
          <img src={image} alt="Go Live" />
        </aside>
      )}
    </Stack>
  );
}
